// Messaging.js (with message input area)

import React, { useState, useEffect, useRef, useMemo } from 'react';
import './Messaging.css';
import {
  getGroupsForUser,
  getUserLists,
  getListMembers, 
  showConfirmToast, 
  createGroupInFirestore,
  sendMessageToConversation,
  getOrCreateDirectConversation,
} from '../firebase/messagingUtils';
import { getAuth } from 'firebase/auth';
import { collection, arrayUnion, onSnapshot, getDocs, updateDoc, query,
   orderBy, where, doc, getDoc, setDoc, addDoc, deleteDoc, documentId, serverTimestamp, } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import GroupChat from '../components/GroupChat';
import DirectChat from '../components/DirectChat';
import PageInfoButton from '../components/PageInfoButton';
import { toast, ToastContainer } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { getStatesWithHomeFirst } from '../utils/states';
import { clearAllMissedCallNotifications } from '../utils/missedCallNotifications';




 
  const auth = getAuth();
  
  


const Messaging = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const normalizeSearchUser = (user = {}) => ({
    ...user,
    isFederal: user.isFederal === true,
  });
  const compareSearchUsersByName = (a = {}, b = {}) => {
    const aLast = String(a.lastName || a.displayId || '').toLowerCase();
    const bLast = String(b.lastName || b.displayId || '').toLowerCase();
    const lastCompare = aLast.localeCompare(bLast);
    if (lastCompare !== 0) return lastCompare;

    const aName = String(a.firstName || a.firstInitialLastName || a.fullName || '').toLowerCase();
    const bName = String(b.firstName || b.firstInitialLastName || b.fullName || '').toLowerCase();
    return aName.localeCompare(bName);
  };
  const [userId, setUserId] = useState(null);
  const [groups, setGroups] = useState([]);
  const [showGroups, setShowGroups] = useState(true);
  const [activeOnly, setActiveOnly] = useState(false);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [newGroupName, setNewGroupName] = useState('');

  useEffect(() => {
    clearAllMissedCallNotifications();
  }, []);
  const [currentChatId, setCurrentChatId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [activeGroupId, setActiveGroupId] = useState(null);
  const [activeDirectId, setActiveDirectId] = useState(null);
  const { currentUser } = useUser();
  const [activeDMUserIds, setActiveDMUserIds] = useState([]);
  const [dmUnreadMap, setDmUnreadMap] = useState({});
  const [localGroupNames, setLocalGroupNames] = useState({});
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [searchFields, setSearchFields] = useState({});
  const [searchResults, setSearchResults] = useState([]);
  const [agencyList, setAgencyList] = useState([]);
  const [agencyFilter, setAgencyFilter] = useState('');
  const [agencyDropdownOpen, setAgencyDropdownOpen] = useState(false);
  const [assignmentList, setAssignmentList] = useState([]);
  const [rankList, setRankList] = useState([]);
  const [searchState, setSearchState] = useState('');
  const [stateHasSearchableUsers, setStateHasSearchableUsers] = useState(true);
  const [activeDMUsers, setActiveDMUsers] = useState([]);
  const [userLists, setUserLists] = useState([]);
  const [listMembers, setListMembers] = useState({}); // { listId: [userObjects] }
  const [showCreateListModal, setShowCreateListModal] = useState(false);
  const [newListName, setNewListName] = useState('');
  const [openMenu, setOpenMenu] = useState({ listId: null, userId: null });
  const [expandedListId, setExpandedListId] = useState(null);
  const [selectedListId, setSelectedListId] = useState(null);
  const [searchContext, setSearchContext] = useState(null);
  const [selectedSearchUserIds, setSelectedSearchUserIds] = useState([]);
  const [selectAllResults, setSelectAllResults] = useState(false);
  const [searchUserMenuOpen, setSearchUserMenuOpen] = useState(null); 
  const [showSingleAddModal, setShowSingleAddModal] = useState(false);
  const [userToAddToList, setUserToAddToList] = useState(null);
  const [groupSelectorUser, setGroupSelectorUser] = useState(null);
  const [userGroups, setUserGroups] = useState([]);
  const [groupsLoading, setGroupsLoading] = useState(false);
  const [showCreateGroupModal, setShowCreateGroupModal] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [editingListId, setEditingListId] = useState(null);
  const [editedListName, setEditedListName] = useState('');
  const [addingToListLoading, setAddingToListLoading] = useState(false);
  const [addingToListId, setAddingToListId] = useState(null);
  const [showSearchInfo, setShowSearchInfo] = useState(false);
  const [dmConversations, setDmConversations] = useState([]);
  const [authUid, setAuthUid] = useState(null);
  const [pendingCallUserId, setPendingCallUserId] = useState(null);
  const [searchStateTouched, setSearchStateTouched] = useState(false);
  const [searchNoteMap, setSearchNoteMap] = useState({});
  const [openSearchNoteId, setOpenSearchNoteId] = useState(null);

  
 

	const infoBoxRef = useRef(null);


	useEffect(() => {
  const stop = getAuth().onAuthStateChanged(u => setAuthUid(u?.uid || null));
  return stop;
}, []);

	useEffect(() => {
  if (!location.state?.convoDeleted) return;

  toast.info('This conversation was deleted by the other user.');
  navigate(location.pathname, { replace: true, state: null });
}, [location.pathname, location.state, navigate]);


	useEffect(() => {
  const handleClickOutside = (event) => {
    if (infoBoxRef.current && !infoBoxRef.current.contains(event.target)) {
      setShowSearchInfo(false);
    }
  };

  if (showSearchInfo) {
    document.addEventListener('mousedown', handleClickOutside);
  } else {
    document.removeEventListener('mousedown', handleClickOutside);
  }

  return () => document.removeEventListener('mousedown', handleClickOutside);
}, [showSearchInfo]);



  useEffect(() => {
  if (searchState) {
    fetchDropdownOptionsForState(searchState);
    return;
  }

  setAgencyList([]);
  setAssignmentList([]);
  setRankList([]);
  setStateHasSearchableUsers(false);
}, [searchState]);

  useEffect(() => {
    setAgencyFilter('');
    setAgencyDropdownOpen(false);
  }, [searchState, showSearchModal]);



  useEffect(() => {
    if (currentUser?.uid) {
      setUserId(currentUser.uid);
    }
  }, [currentUser?.uid]);



	  const handleRemoveUserFromList = async (userId, listId) => {
  if (!currentUser?.uid || !userId || !listId) return;

  try {
    const memberRef = doc(db, 'users', currentUser.uid, 'userLists', listId, 'members', userId);
    await deleteDoc(memberRef);
    toast.success('User removed from list.');
    await fetchListsAndMembers(); // ✅ refresh UI
  } catch (err) {
    console.error('❌ Failed to remove user from list:', err);
    toast.error('Failed to remove user.');
  }
};


	const refreshGroupList = async () => {
  if (!userId) return;

  try {
    const q = query(
      collection(db, 'conversations'),
      where('isGroup', '==', true),
      where('members', 'array-contains', userId)
    );

    const snapshot = await getDocs(q);
    const groupList = [];

    for (const docSnap of snapshot.docs) {
      const data = docSnap.data();
      if (data.deleting === true) continue;
      const groupId = docSnap.id;

      const latestMessageTime = data.lastMessageAt
  ? (data.lastMessageAt.toDate ? data.lastMessageAt.toDate() : new Date(data.lastMessageAt))
  : null;

      const viewDocRef = doc(db, 'conversations', groupId, 'views', userId);
      const viewDocSnap = await getDoc(viewDocRef);
      const lastViewed = viewDocSnap.exists() ? viewDocSnap.data().lastViewed?.toDate?.() : null;

     const lastSender = data.lastMessageSender || null;
const hasUnread = lastViewed && latestMessageTime
  ? latestMessageTime > lastViewed && lastSender !== userId
  : latestMessageTime && lastSender !== userId;


      groupList.push({
        id: groupId,
        ...data,
        hasUnread,
        createdAt: data.createdAt?.seconds
          ? new Date(data.createdAt.seconds * 1000)
          : new Date(data.createdAt),
      });
    }

    setGroups(groupList.sort((a, b) => b.createdAt - a.createdAt));
  } catch (err) {
    console.error('Failed to fetch groups:', err);
  }
};


const handleAddSearchField = (field) => {
  if (field && !searchFields.hasOwnProperty(field)) {
    setSearchFields((prev) => ({ ...prev, [field]: '' }));
  }
};

const handleRemoveSearchField = (field) => {
  const updated = { ...searchFields };
  delete updated[field];
  setSearchFields(updated);
};

const markConversationViewedBestEffort = (conversationId, viewerId) => {
  if (!conversationId || !viewerId) return;

  const viewRef = doc(db, 'conversations', conversationId, 'views', viewerId);
  void setDoc(viewRef, { lastViewed: serverTimestamp() }, { merge: true }).catch((err) => {
    if (err?.code !== 'permission-denied') {
      console.error('views write failed:', err);
    }
  });
};

const loadSearchResultNotes = async (resultUsers) => {
  const currentUid = currentUser?.uid;
  if (!currentUid || !Array.isArray(resultUsers) || resultUsers.length === 0) {
    setSearchNoteMap({});
    return;
  }

  try {
    const noteEntries = await Promise.all(
      resultUsers.map(async (resultUser) => {
        const noteRef = doc(db, 'users', currentUid, 'profileNotes', resultUser.id);
        const noteSnap = await getDoc(noteRef);
        if (!noteSnap.exists()) return null;

        const data = noteSnap.data();
        if (!data.text || !data.text.trim()) return null;
        return [resultUser.id, { id: noteSnap.id, ...data }];
      })
    );

    setSearchNoteMap(Object.fromEntries(noteEntries.filter(Boolean)));
  } catch (err) {
    console.error('Failed to load private note indicators:', err);
    setSearchNoteMap({});
  }
};


const handleRunSearch = async () => {
  if (searchState && !stateHasSearchableUsers) {
    toast.error('No agencies found for this state yet.');
    return;
  }

  // ✅ Check 1: Prevent no filters at all (empty or whitespace)
  const hasValidFilters =
    Object.values(searchFields).some((val) => val?.trim?.() !== '') ||
    activeOnly;

  if (!hasValidFilters) {
    toast.error('Please select at least one filter before searching.');
    return;
  }

  // ✅ Check 2: Make sure user didn't only set state with no specific filters
  const onlyStateSet =
    searchState &&
    !searchFields.lastName &&
    !searchFields.agency &&
    !searchFields.assignment &&
    !searchFields.rank &&
    !activeOnly;

  if (onlyStateSet) {
    toast.error('Please add at least one additional filter besides state.');
    return;
  }

	setHasSearched(true);

  try {
    const userCollection = collection(db, 'users');
    let q = userCollection;

    if (searchState) {
      q = query(q, where('state', '==', searchState));
    }

    Object.entries(searchFields).forEach(([field, value]) => {
      if (value && value.trim() !== '') {
        if (field === 'lastName') {
          q = query(q, where('lastNameLower', '==', value.trim().toLowerCase()));
        } else {
          q = query(q, where(field, '==', value.trim()));
        }
      }
    });

     if (activeOnly) {
    	q = query(q, where('dutyStatus', '==', 'on-duty'));
  	}


    const snapshot = await getDocs(q);
    const allUsers = snapshot.docs.map((doc) =>
      normalizeSearchUser({ id: doc.id, ...doc.data() })
    );

// ✅ Exclude current user from results
const filteredUsers = allUsers
  .filter((u) => u.id !== currentUser?.uid)
  .sort(compareSearchUsersByName);

setSearchResults(filteredUsers);
await loadSearchResultNotes(filteredUsers);

  } catch (err) {
    console.error('Failed to run user search:', err);
    setSearchNoteMap({});
  }

  setShowSearchModal(false);
};



const handleAddUserToList = async (userId, listId = selectedListId) => {
  if (!currentUser?.uid || !userId || !listId) return false;

  const memberRef = doc(db, 'users', currentUser.uid, 'userLists', listId, 'members', userId);
  const memberSnap = await getDoc(memberRef);

  if (memberSnap.exists()) {
    return false; // already in list
  }

  const userDoc = await getDoc(doc(db, 'users', userId));
  if (!userDoc.exists()) return false;

  await setDoc(memberRef, userDoc.data());
  return true;
};




const ensureDirectConversation = async (targetUserId) => {
  const currentUserId = auth.currentUser?.uid;
  if (!currentUserId || currentUserId === targetUserId) return null;

  try {
    const sortedKey = [currentUserId, targetUserId].sort().join('_');
    const existing = dmConversations.find(
      (c) =>
        c.dmKey === sortedKey ||
        (Array.isArray(c.members) && [...c.members].sort().join('_') === sortedKey)
    );

    let convoId = existing?.id;

    if (!convoId) {
      const [meSnap, otherSnap] = await Promise.all([
        getDoc(doc(db, 'users', currentUserId)),
        getDoc(doc(db, 'users', targetUserId))
      ]);
      const me = meSnap.exists() ? meSnap.data() : {};
      const other = otherSnap.exists() ? otherSnap.data() : {};

      convoId = await getOrCreateDirectConversation(currentUserId, targetUserId, {
        memberProfiles: {
          [currentUserId]: {
            firstInitialLastName: me.firstInitialLastName || null,
            agency: me.agency || null,
            rank: me.rank || null,
            avatarUrl: me.avatarUrl || null,
          },
          [targetUserId]: {
            firstInitialLastName: other.firstInitialLastName || null,
            agency: other.agency || null,
            rank: other.rank || null,
            avatarUrl: other.avatarUrl || null,
          }
        }
      });
    }

    return convoId;
  } catch (err) {
    console.error("Failed to ensure DM conversation:", err);
    return null;
  }
};

const openDirectConversation = async (targetUserId, { autoCall = false } = {}) => {
  setOpenMenu({ listId: null, userId: null });
  setSearchUserMenuOpen(null);

  const convoId = await ensureDirectConversation(targetUserId);
  const currentUserId = auth.currentUser?.uid;
  if (!convoId || !currentUserId) return;

  setCurrentChatId(convoId);
  setActiveDirectId(convoId);
  markConversationViewedBestEffort(convoId, currentUserId);

  if (autoCall) {
    setPendingCallUserId(targetUserId);
  }
};

const handleMessageUser = async (targetUserId) => {
  await openDirectConversation(targetUserId);
};

const handleCallUser = async (targetUserId) => {
  await openDirectConversation(targetUserId, { autoCall: true });
};


const selectedConvo = useMemo(
  () => dmConversations.find(c => c.id === currentChatId),
  [dmConversations, currentChatId]
);

const otherUser = useMemo(() => {
  if (!selectedConvo || !currentUser?.uid) return null;
  const otherUid = (selectedConvo.members || []).find(u => u !== currentUser.uid);
  if (!otherUid) return null;
  return {
    id: otherUid,
    firstInitialLastName: selectedConvo.memberProfiles?.[otherUid]?.firstInitialLastName || null,
    agency: selectedConvo.memberProfiles?.[otherUid]?.agency || null,
    rank: selectedConvo.memberProfiles?.[otherUid]?.rank || null,
    avatarUrl: selectedConvo.memberProfiles?.[otherUid]?.avatarUrl || null,
  };
}, [selectedConvo, currentUser?.uid]);


const handleViewProfile = (targetUserId) => {
  setOpenMenu({ listId: null, userId: null });
  setSearchUserMenuOpen(null);

  if (!targetUserId) {
    console.warn('⚠️ No user ID provided for profile view');
    return;
  }

  // Navigate to the user’s profile page
  navigate(`/profile/${targetUserId}`);
};



const handleAddToGroupFromList = async (user) => {
  setGroupSelectorUser(user); // 👤 this is the user you're trying to add
  setGroupsLoading(true);     // show loading spinner

  try {
    const groups = await fetchUserGroups(currentUser.uid); // 🔁 reuse your existing function
    setUserGroups(groups);
  } catch (err) {
    console.error('Error loading user groups:', err);
    setUserGroups([]);
  }

  setGroupsLoading(false);
  setShowGroupModal(true); // ✅ now open modal
};



	const fetchListsAndMembers = async () => {
  if (!currentUser?.uid) return;

  const lists = await getUserLists(currentUser.uid);

// ✅ Sort newest first
lists.sort((a, b) => {
  const aTime = a.createdAt?.seconds ? a.createdAt.seconds : new Date(a.createdAt).getTime();
  const bTime = b.createdAt?.seconds ? b.createdAt.seconds : new Date(b.createdAt).getTime();
  return bTime - aTime;
});

setUserLists(lists);



  const membersMap = {};

  for (const list of lists) {
    const memberIds = await getListMembers(currentUser.uid, list.id);
    const memberData = [];

    for (const userId of memberIds) {
      if (userId === currentUser.uid) continue; // skip self
      const userSnap = await getDoc(doc(db, 'users', userId));
      if (userSnap.exists()) {
        memberData.push({ id: userId, ...userSnap.data() });
      }
    }

    membersMap[list.id] = memberData;
  }

  setListMembers(membersMap);
};
	


	const menuRef = useRef();


useEffect(() => {
  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setOpenMenu(null);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);	




	const searchMenuRef = useRef(null);
  const agencyDropdownRef = useRef(null);

useEffect(() => {
  const handleClickOutside = (e) => {
    if (searchMenuRef.current && !searchMenuRef.current.contains(e.target)) {
      setSearchUserMenuOpen(null);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);

useEffect(() => {
  if (!agencyDropdownOpen) return;
  const handleClickOutside = (e) => {
    if (agencyDropdownRef.current && !agencyDropdownRef.current.contains(e.target)) {
      setAgencyDropdownOpen(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, [agencyDropdownOpen]);




useEffect(() => {
  const fetchDMUsers = async () => {
    if (activeDMUserIds.length === 0) {
      setActiveDMUsers([]);
      return;
    }

    const userDocs = await Promise.all(
      activeDMUserIds.map((id) => getDoc(doc(db, 'users', id)))
    );

    const userList = userDocs
      .filter((docSnap) => docSnap.exists())
      .map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));

    setActiveDMUsers(userList);
  };

  fetchDMUsers();
}, [activeDMUserIds]);

	useEffect(() => {
  if (userId) {
    refreshGroupList();
  }
}, [userId]);



	useEffect(() => {
  if (!currentUser?.uid) return;

  const q = query(
    collection(db, 'conversations'),
    where('isGroup', '==', true),
    where('members', 'array-contains', currentUser.uid)
  );

  const unsubscribe = onSnapshot(q, async (snapshot) => {
  try {
  const updatedGroups = [];

  for (const docSnap of snapshot.docs) {
    const data = docSnap.data();
    if (data.deleting === true) continue;
    const groupId = docSnap.id;

    const latestMessageTime = data.lastMessageAt
      ? (data.lastMessageAt.toDate ? data.lastMessageAt.toDate() : new Date(data.lastMessageAt))
      : null;

    const viewDocRef = doc(db, 'conversations', groupId, 'views', currentUser.uid);
    const viewDocSnap = await getDoc(viewDocRef);
    const lastViewed = viewDocSnap.exists() ? viewDocSnap.data().lastViewed?.toDate?.() : null;

    const lastSender = data.lastMessageSender || null;
    const hasUnread =
      lastViewed && latestMessageTime
        ? latestMessageTime > lastViewed && lastSender !== currentUser.uid
        : latestMessageTime && lastSender !== currentUser.uid;
        // 🟡 DEBUG: Log what each group sees
      console.log(
        `🟡 Group "${data.name}" → lastMessageAt:`,
        latestMessageTime,
        'lastViewed:',
        lastViewed,
        'lastSender:',
        lastSender,
        'hasUnread:',
        hasUnread
      );

    updatedGroups.push({
      id: groupId,
      ...data,
      hasUnread,
      createdAt: data.createdAt?.seconds
        ? new Date(data.createdAt.seconds * 1000)
        : new Date(data.createdAt),
    });
  }

  setGroups(updatedGroups.sort((a, b) => b.createdAt - a.createdAt));
  } catch (error) {
    console.error('Group snapshot processing error:', error);
  }
}, (error) => {
  console.error('Group list listener error:', error);
});

  return () => unsubscribe();
}, [currentUser?.uid]);
	


   const auth = getAuth();
   const chatEndRef = useRef(null);
   



  useEffect(() => {
  console.log('Current chat ID:', currentChatId);
  if (!currentChatId) return;

	console.log('📡 Listening to messages for:', currentChatId);

  const q = collection(db, 'conversations', currentChatId, 'messages');
  const unsubscribe = onSnapshot(q, (snapshot) => {
    const msgs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setMessages(msgs);
  }, (error) => {
    console.error('Conversation messages listener error:', error);
  });

  return () => unsubscribe();
}, [currentChatId]);


  useEffect(() => {
  if (chatEndRef.current) {
    chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
  }
}, [messages]);



  useEffect(() => {
  const me = currentUser?.uid;
  if (!me) return;

  const q = query(
    collection(db, 'conversations'),
    where('isGroup', '==', false),
    where('members', 'array-contains', me),
    orderBy('lastMessageAt', 'desc')
  );

  const unsub = onSnapshot(q, async (snap) => {
    const items = [];

    for (const docSnap of snap.docs) {
      const data = docSnap.data();
      if (data.deleting === true) continue;

      // compute unread for me
      let hasUnread = false;
      try {
        const viewRef = doc(db, 'conversations', docSnap.id, 'views', me);
        const viewSnap = await getDoc(viewRef);
        const lastViewed = viewSnap.exists() ? viewSnap.data().lastViewed?.toDate?.() : null;
        const lastMessageAt = data.lastMessageAt?.toDate?.();
        const lastSender = data.lastMessageSender;
        const lastCallLogAt = data.lastCallLogAt?.toDate?.();
        const lastCallLogType = data.lastCallLogType;
        const lastCallLogBy = data.lastCallLogBy;

        const messageUnread = !!(
          docSnap.id !== currentChatId &&
          lastMessageAt &&
          (!lastViewed || lastMessageAt > lastViewed) &&
          lastSender !== me
        );

        const missedCallUnread = !!(
          docSnap.id !== currentChatId &&
          lastCallLogType === 'missed' &&
          lastCallLogBy &&
          lastCallLogBy !== me &&
          lastCallLogAt &&
          (!lastViewed || lastCallLogAt > lastViewed)
        );

        hasUnread = messageUnread || missedCallUnread;
      } catch (e) {
        // ignore
      }

      items.push({ id: docSnap.id, ...data, hasUnread });
    }

    // dedupe by dmKey or sorted members; keep newest by lastMessageAt
    const map = new Map();
    for (const c of items) {
      const key = c.dmKey || (Array.isArray(c.members) ? [...c.members].sort().join('_') : c.id);
      const prev = map.get(key);
      if (!prev) {
        map.set(key, c);
      } else {
        const a = c.lastMessageAt?.seconds || 0;
        const b = prev.lastMessageAt?.seconds || 0;
        map.set(key, a > b ? c : prev);
      }
    }

    setDmConversations([...map.values()]);
  }, (error) => {
    console.error('DM list listener error:', error);
  });

  return () => unsub();
}, [currentUser?.uid, currentChatId]);



// 👁️ Listen for updates in *my* view documents across all groups
useEffect(() => {
  return undefined;

  const q = query(
    collection(db, '__disabled_views_listener__'),
    where('userId', '==', currentUser.uid)
  );

  const unsub = onSnapshot(q, () => {
    console.log('👁️ View doc changed → refreshing group list');
    refreshGroupList();
  });

  return () => unsub();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [currentUser?.uid]);



useEffect(() => {
  if (currentUser?.uid) {
    fetchListsAndMembers();
  }
}, [currentUser?.uid]);



	const handleSaveListName = async (listId) => {
  if (!editedListName.trim()) return;
  try {
    const listRef = doc(db, 'users', currentUser.uid, 'userLists', listId);
    await updateDoc(listRef, { name: editedListName.trim() });
    toast.success('List name updated.');
    setEditingListId(null);
    await fetchListsAndMembers();
  } catch (err) {
    console.error('Failed to update list name:', err);
    toast.error('Error saving list name.');
  }
};

const handleDeleteList = async (listId) => {
  showConfirmToast('Are you sure you want to delete this list?', async () => {
    try {
      // Delete the list doc
      const listRef = doc(db, 'users', currentUser.uid, 'userLists', listId);
      await deleteDoc(listRef);

      // Delete the members subcollection
      const membersSnap = await getDocs(collection(listRef, 'members'));
      const deletePromises = membersSnap.docs.map((doc) => deleteDoc(doc.ref));
      await Promise.all(deletePromises);

      toast.success('List deleted.');
      await fetchListsAndMembers();
    } catch (err) {
      console.error('Failed to delete list:', err);
      toast.error('Error deleting list.');
    }
  });
};

  const handleCreateGroup = async () => {
  console.log('Create button clicked');

  if (!newGroupName.trim()) {
    console.warn('Group name is empty');
    return;
  }

  const allMembers = [userId];


const newGroup = {
  name: newGroupName.trim(),
  members: allMembers,
  createdAt: new Date().toISOString(),
  isGroup: true
};

  try {
    const groupId = await createGroupInFirestore(newGroup);
    setGroups([...groups, { id: groupId, ...newGroup }]);
    setNewGroupName('');
    setShowCreateGroupModal(false);
    await refreshGroupList(); // ✅ Refresh view
    console.log('Group created successfully');
  } catch (error) {
    console.error('Failed to create group:', error);
  }
};




const refreshActiveDMs = async () => {
  if (!currentUser?.uid) return;

  try {
    const q = query(
      collection(db, 'conversations'),
      where('isGroup', '==', false),
      where('members', 'array-contains', currentUser.uid)
    );

    const snapshot = await getDocs(q);
    const ids = [];
    const unreadMap = {};

    for (const docSnap of snapshot.docs) {
      const data = docSnap.data();
      if (data.deleting === true) continue;
      const convoId = docSnap.id;
      const otherUserId = data.members?.find(id => id !== currentUser.uid);
      if (!otherUserId) continue;

      ids.push(otherUserId);

      const viewRef = doc(db, 'conversations', convoId, 'views', currentUser.uid);
      const viewSnap = await getDoc(viewRef);
      const lastViewed = viewSnap.exists() ? viewSnap.data().lastViewed?.toDate?.() : null;

      // 🔍 Fetch most recent message
      const messagesRef = collection(db, 'conversations', convoId, 'messages');
      const lastMsgQuery = query(
        messagesRef,
        where('deleted', '==', false),
        orderBy('createdAt', 'desc')
      );
      const messagesSnap = await getDocs(lastMsgQuery);
      const lastDoc = messagesSnap.docs[0];

      if (!lastDoc) {
        unreadMap[otherUserId] = false;
        continue;
      }

      const lastMessage = lastDoc.data();
      const isUnread =
        lastMessage.senderId !== currentUser.uid &&
        (!lastViewed || lastMessage.createdAt?.toDate() > lastViewed);

      unreadMap[otherUserId] = isUnread;
    }

    setActiveDMUserIds(ids);
    setDmUnreadMap(unreadMap);
  } catch (err) {
    console.error('Failed to refresh DM list:', err);
  }
};

const fetchDropdownOptionsForState = async (stateName) => {
  const lookupState = String(stateName || '').trim();
  if (!lookupState) {
    setAgencyList([]);
    setAssignmentList([]);
    setRankList([]);
    setStateHasSearchableUsers(false);
    return;
  }

  try {
    const [agencyResult, profileLookupResult] = await Promise.allSettled([
      getDoc(doc(db, 'agenciesByState', lookupState)),
      getDoc(doc(db, 'profileSearchLookupsByState', lookupState)),
    ]);

    if (agencyResult.status === 'rejected') {
      throw agencyResult.reason;
    }

    const agencySnap = agencyResult.value;
    const profileLookupSnap =
      profileLookupResult.status === 'fulfilled' ? profileLookupResult.value : null;

    if (profileLookupResult.status === 'rejected') {
      console.warn('Failed to fetch state profile lookup options:', profileLookupResult.reason);
    }

    const agencies = agencySnap.exists() && Array.isArray(agencySnap.data().agencies)
      ? [...agencySnap.data().agencies].filter(Boolean).sort((a, b) => a.localeCompare(b))
      : [];
    const lookupData = profileLookupSnap?.exists() ? profileLookupSnap.data() : {};
    const assignments = Array.isArray(lookupData.assignments)
      ? [...lookupData.assignments].filter(Boolean).sort((a, b) => a.localeCompare(b))
      : [];
    const ranks = Array.isArray(lookupData.ranks)
      ? [...lookupData.ranks].filter(Boolean).sort((a, b) => a.localeCompare(b))
      : [];

    setAgencyList(agencies);
    setAssignmentList(agencies.length > 0 ? assignments : []);
    setRankList(agencies.length > 0 ? ranks : []);
    setStateHasSearchableUsers(agencies.length > 0);
  } catch (err) {
    console.error('Failed to fetch dropdown options:', err);
    setAgencyList([]);
    setAssignmentList([]);
    setRankList([]);
    setStateHasSearchableUsers(false);
  }
};


const handleCreateList = async () => {
  const trimmedName = newListName.trim();
  if (!trimmedName) return;

  try {
    const currentUserId = auth.currentUser?.uid;
    if (!currentUserId) return;

    const newListRef = doc(collection(db, 'users', currentUserId, 'userLists'));
await setDoc(newListRef, {
  name: trimmedName,
  createdAt: new Date(),
});

    // Update local state immediately
    setUserLists(prev => [...prev, { id: newListRef.id, name: trimmedName }]);
    setNewListName('');
    setShowCreateListModal(false);
    await fetchListsAndMembers();
  } catch (err) {
    console.error('❌ Failed to create list:', err);
  }
};



	const handleAddUserToExistingGroup = async (groupId, userIdToAdd) => {
  try {
    const groupRef = doc(db, 'conversations', groupId);
    await updateDoc(groupRef, {
      members: arrayUnion(userIdToAdd),
    });
    toast.success('User added to group.');
    setShowGroupModal(false);
  } catch (err) {
    console.error('Failed to add user to group:', err);
    toast.error('Error adding user.');
  }
};



	const fetchUserGroups = async (userId) => {
  const q = query(
    collection(db, 'conversations'),
    where('isGroup', '==', true),
    where('members', 'array-contains', userId)
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};




	const handleAddUsersToExistingGroup = async (groupId, userIdsToAdd) => {
  try {
    const groupRef = doc(db, 'conversations', groupId);
    await updateDoc(groupRef, {
      members: arrayUnion(...userIdsToAdd),
    });
    toast.success('Users added to group.');
    setShowGroupModal(false);
  } catch (err) {
    console.error('Failed to add users to group:', err);
    toast.error('Error adding users.');
  }
};



	const openGroupSelectorForSelectedUsers = async () => {
  setGroupsLoading(true);
  const allGroups = await fetchUserGroups(currentUser.uid);
  setUserGroups(allGroups);
  setGroupsLoading(false);
  setShowGroupModal(true);
};





  return (
     <>
  {activeGroupId ? (
  <GroupChat
    currentUser={currentUser}
    groupId={activeGroupId}
    onBack={(state = null) => {
      setActiveGroupId(null);
      if (state?.convoDeleted) {
        toast.info('This conversation was deleted by the other user.');
      }
    }}
    refreshGroupList={refreshGroupList}
  />
) : activeDirectId ? (
  <DirectChat
    chatId={currentChatId}
    currentUser={currentUser}
    otherUser={otherUser}
    autoCallTarget={pendingCallUserId}
    onAutoCallConsumed={() => setPendingCallUserId(null)}
    onBack={(state = null) => {
      setActiveDirectId(null);
      setCurrentChatId(null);
      setPendingCallUserId(null);
      if (state?.convoDeleted) {
        toast.info('This conversation was deleted by the other user.');
      }
    }}
  />

) : (

  <div className="messaging-page"> 

  <div className="page-info-header-block">
    <h2>Messaging</h2>
    <div className="page-info-button-wrapper">
      <PageInfoButton title="About Messaging">
        <p>
          Tap the search button (magnifying glass) and pick any filters you want. You can combine
          multiple filters and the results will appear right under the search button; the three-dot menu
          next to each name holds the interaction options.
        </p>
        <ul className="page-info-list">
          <li>
            <strong>Groups:</strong> The Groups section is collapsible. When open, use Create Group to
            start a new room. Add members from the search results via each user's three-dot menu, or from the three-dot menu inside the group. Members can leave the group at any time. The last member can delete it. 
          </li>
          <li>
            <strong>Direct conversations:</strong> Recent direct chats appear in the list.
            Tap a name to jump straight into the conversation.
          </li>
	  <li>
            <strong>Voice Calls:</strong> Start a voice call with another user by tapping the 			call button in the top-right corner  inside a conversation thread.
          </li>
          <li>
            <strong>My Contact Lists:</strong> Create a custom list, then save users into it for quick access.
            Users can be added through the search results at the top of the page once the list exists.
          </li>
        </ul>
      </PageInfoButton>
    </div>
  </div>

  <div className="messaging-info">
    <div className="messaging-info-logo-panel" aria-hidden="true">
      <img src="/bluewire-messaging-logo.png" alt="" className="messaging-info-logo" />
    </div>
    <div className="messaging-info-list">
      <div className="messaging-info-item">
        <span className="messaging-info-icon messaging-info-icon-search" aria-hidden="true" />
        <span>Use search to find users from other agencies and message them directly.</span>
      </div>
      <div className="messaging-info-item">
        <span className="messaging-info-icon messaging-info-icon-message" aria-hidden="true" />
        <span>Connect directly for one-on-one conversations and voice calls.</span>
      </div>
      <div className="messaging-info-item">
        <span className="messaging-info-icon messaging-info-icon-group" aria-hidden="true" />
        <span>Create and save groups for future collaboration and ongoing chats.</span>
      </div>
      <div className="messaging-info-item">
        <span className="messaging-info-icon messaging-info-icon-bookmark" aria-hidden="true" />
        <span>Save members in custom lists for quick access later.</span>
      </div>
    </div>
  </div>

 
      <div className="messaging-search-controls">
        <div className="messaging-search-info-row">
          <button
            className="info-icon messaging-search-help-button"
            onClick={() => setShowSearchInfo(!showSearchInfo)}
            title="How to use search"
            aria-label="How to use search"
            type="button"
          >
            ℹ️
          </button>
        </div>
  <button
    className="messaging-search-launch-button"
    onClick={() => {
  if (!currentUser?.state) return;
  setSearchFields({});
  setSearchResults([]);
  setSearchNoteMap({});
  setOpenSearchNoteId(null);
  setSearchState(currentUser?.state || '');
  setSearchStateTouched(false);
  setSelectedListId(null);
  setShowSearchModal(true);
}}
    title="Open advanced search"
    type="button"
  >
    🔍Search...
  </button>
  <div className="toggle-and-info">
  <span className="toggle-prefix">Show:</span>
  <label className="toggle-active compact-toggle">
    <input
      type="checkbox"
      checked={activeOnly}
      onChange={() => setActiveOnly(!activeOnly)}
    />
    <span>on-duty only</span>
    <span className="toggle-marker duty-badge" aria-hidden="true">✔️</span>
  </label>

<button
    className="info-icon"
    onClick={() => setShowSearchInfo(!showSearchInfo)}
    title="How to use search"
    style={{
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      fontSize: '1.2rem',
      marginLeft: '8px'
    }}
  >
    ℹ️
  </button>
</div>
</div>

	{showSearchInfo && (
  <div
    ref={infoBoxRef}	
    style={{
      backgroundColor: '#f1f1f1',
      border: '1px solid #ccc',
      padding: '10px',
      margin: '10px 0',
      borderRadius: '6px',
      fontSize: '0.9rem',
      maxWidth: '500px'
    }}
  >
    <strong>Search Tips:</strong>
    <ul style={{ margin: '8px 0 0 16px', padding: 0 }}>
	 <li>• You can use multiple filters at once (e.g., Agency + Rank + Last Name) to narrow results.</li>
	 <li>• Users currently on duty will be marked (✔️).</li>
      <li>• Select the <em>“Show on-duty only”</em> checkbox before searching to see only users currently on duty.</li>
     
    </ul>
  </div>
)}



{showSearchModal && (
  <div className="modal-overlay" onClick={() => setShowSearchModal(false)}>
  <div className="search-modal-content" onClick={(e) => e.stopPropagation()}>

    <div className="search-field-row">
  <label>
    State:&nbsp;
    <select
      value={searchState}
      onChange={(e) => {
        setSearchStateTouched(true);
        setSearchState(e.target.value);
      }}
    >
      {getStatesWithHomeFirst(currentUser?.state).map((stateName) => (
        <option key={stateName} value={stateName}>{stateName}</option>
      ))}
    </select>
  </label>
</div>
    {searchState && !stateHasSearchableUsers && (
      <div className="search-field-row" style={{ color: '#8a4b00', fontSize: '0.9rem' }}>
        No agencies found for this state yet.
      </div>
    )}
	<div className="search-field-row">
        <label>
          Search by:
          <select
            onChange={(e) => handleAddSearchField(e.target.value)}
            value=""
            style={{ marginLeft: '8px' }}
            disabled={Boolean(searchState && !stateHasSearchableUsers)}
          >
            <option value="">Select filters</option>
            <option value="agency">Agency</option>
            <option value="assignment">Assignment</option>
            <option value="rank">Rank</option>
            <option value="lastName">Last Name</option>
          </select>
        </label>
      </div>

{Object.entries(searchFields).map(([field, value]) => (
        <div key={field} className="search-field-row">
          <div className="search-field-label">
            {field.replace(/([A-Z])/g, ' $1')}
          </div>
          <div className="search-field-control">
            {field === 'agency' && (
              <div className="agency-select" ref={agencyDropdownRef}>
                <button
                  type="button"
                  className="agency-select-trigger"
                  onClick={() => setAgencyDropdownOpen((prev) => !prev)}
                >
                  {value || "Select agency"}
                </button>
                {agencyDropdownOpen && (
                  <div className="agency-select-panel">
                    <input
                      type="text"
                      value={agencyFilter}
                      onChange={(e) => setAgencyFilter(e.target.value)}
                      placeholder="Filter agencies..."
                      className="agency-select-filter"
                    />
                    <div className="agency-select-options">
                      {agencyList
                        .filter((agency) => {
                          if (!agencyFilter.trim()) return true;
                          return agency.toLowerCase().startsWith(agencyFilter.trim().toLowerCase());
                        })
                        .map((agency) => (
                          <button
                            key={agency}
                            type="button"
                            className={`agency-select-option${agency === value ? " selected" : ""}`}
                            onClick={() => {
                              setSearchFields((prev) => ({ ...prev, [field]: agency }));
                              setAgencyDropdownOpen(false);
                              setAgencyFilter('');
                            }}
                          >
                            {agency}
                          </button>
                        ))}
                      {agencyList.filter((agency) => {
                        if (!agencyFilter.trim()) return true;
                        return agency.toLowerCase().startsWith(agencyFilter.trim().toLowerCase());
                      }).length === 0 && (
                        <div className="agency-select-empty">No agencies found</div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}

            {field === 'assignment' && (
              <select
                value={value}
                onChange={(e) =>
                  setSearchFields((prev) => ({ ...prev, [field]: e.target.value }))
                }
              >
                <option value="">Select assignment</option>
                {assignmentList.length === 0 && (
                  <option value="" disabled>No assignments found</option>
                )}
                {assignmentList.map((assignment) => (
                  <option key={assignment} value={assignment}>{assignment}</option>
                ))}
              </select>
            )}

            {field === 'rank' && (
              <select
                value={value}
                onChange={(e) =>
                  setSearchFields((prev) => ({ ...prev, [field]: e.target.value }))
                }
              >
                <option value="">Select rank</option>
                {rankList.length === 0 && (
                  <option value="" disabled>No ranks found</option>
                )}
                {rankList.map((rank) => (
                  <option key={rank} value={rank}>{rank}</option>
                ))}
              </select>
            )}

            {field === 'lastName' && (
              <input
                type="text"
                value={value}
                onChange={(e) =>
                  setSearchFields((prev) => ({ ...prev, [field]: e.target.value }))
                }
                placeholder="Enter last name (lowercase)"
              />
            )}

            <button
              onClick={() => handleRemoveSearchField(field)}
              className="search-field-remove"
              title="Remove filter"
            >
              ❌
            </button>
          </div>
        </div>
      ))}

      <div className="search-modal-buttons">
       <button onClick={handleRunSearch}>Search</button>
         <button onClick={() => setShowSearchModal(false)}>Close</button>
</div>
    </div>
  </div>
)}

{hasSearched && searchResults && (
  <div className="search-results" style={{ padding: '16px' }}>
    <h4>Search Results</h4>

    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginBottom: '12px',
        gap: '12px',
      }}
    >
      <label style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={selectAllResults}
          onChange={() => {
            const allIds = searchResults.map((u) => u.id);
            if (selectAllResults) {
              setSelectedSearchUserIds([]);
            } else {
              setSelectedSearchUserIds(allIds);
            }
            setSelectAllResults(!selectAllResults);
          }}
          style={{ marginRight: '6px' }}
        />
        Select All
      </label>

     {selectedSearchUserIds.length > 0 && (
  <>
   <button
  onClick={() => {
    if (!addingToListLoading) {   // prevent spam clicks
      setUserToAddToList(null);
      setSearchContext({ mode: 'addToListBulk' });
      setShowSingleAddModal(true);
    }
  }}
  disabled={addingToListLoading}
  style={{
    backgroundColor: addingToListLoading ? '#ccc' : '#007bff',
    color: 'white',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '4px',
    cursor: addingToListLoading ? 'not-allowed' : 'pointer',
    opacity: addingToListLoading ? 0.7 : 1,
  }}
>
  {addingToListLoading ? 'Adding...' : '+ Add to List'}
</button>


   <button
  onClick={openGroupSelectorForSelectedUsers}
  style={{
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '4px',
    cursor: 'pointer',
  }}
>
  + Add to Group
</button>

  </>
)}

</div>
 

    {searchResults.length === 0 ? (
      <p style={{ color: '#888' }}>No users matched your search criteria.</p>
    ) : (
      searchResults.map((user) => {
        const privateNote = searchNoteMap[user.id];
        return (
  <div
    key={user.id}
    className="user-list-item"
    style={{
      display: 'flex',
      alignItems: 'center',
      padding: '8px',
      borderBottom: '1px solid #eee',
    }}
  >
    <input
      type="checkbox"
      style={{ marginRight: '10px' }}
      checked={selectedSearchUserIds.includes(user.id)}
      onChange={() => {
        setSelectedSearchUserIds((prev) =>
          prev.includes(user.id)
            ? prev.filter((id) => id !== user.id)
            : [...prev, user.id]
        );
      }}
    />

   <span>
  {`${user.rank || ''} ${user.fullName || `${user.firstName?.[0] || ''}.${user.lastName || 'Unknown'}`}, ${user.assignment || 'Unknown Assignment'}, ${user.agency || 'Unknown Agency'}`}
  {user.isFederal && (
    <span className="fed-badge" title="Federal employee">F</span>
  )}

  {/* ✅ Show a green checkmark if dutyStatus is on-duty */}
  {user.dutyStatus === 'on-duty' && (
    <span style={{ color: 'green', marginLeft: '6px' }}>✔️</span>
  )}
  {privateNote && (
    <button
      className="search-private-note-button"
      onClick={(event) => {
        event.stopPropagation();
        setOpenSearchNoteId((prev) => (prev === user.id ? null : user.id));
        setSearchUserMenuOpen(null);
      }}
      title="View private note"
      aria-label="View private note"
      type="button"
    >
      📝
    </button>
  )}
</span>


    <div style={{ marginLeft: 'auto', position: 'relative' }}>
      <button
        onClick={() =>
          setSearchUserMenuOpen((prev) => (prev === user.id ? null : user.id))
        }
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: '26px',
        }}
      >
        ⋮
      </button>

    {searchUserMenuOpen === user.id && (
  <div className="user-menu" ref={searchMenuRef}>
    <div className="user-menu-item" onClick={() => handleMessageUser(user.id)}>
      Message
    </div>

{/* CALL BUTTON in search results- 
    <div className="user-menu-item" onClick={() => handleCallUser(user.id)}>
      Call
    </div>
*/}
    <div
      className="user-menu-item"
      onClick={() => {
        setUserToAddToList(user);
        setShowSingleAddModal(true);
        setSearchUserMenuOpen(null);
      }}
    >
      Add to List
    </div>
    <div
      className="user-menu-item"
      onClick={() => handleAddToGroupFromList(user)}
    >
      Add to Group
    </div>
    <div className="user-menu-item" onClick={() => handleViewProfile(user.id)}>
      View Profile
    </div>
  </div>
)}

      {privateNote && openSearchNoteId === user.id && (
        <div className="search-private-note-popover">
          <div className="search-private-note-popover-header">
            <strong>Private Note</strong>
            <button
              onClick={() => setOpenSearchNoteId(null)}
              aria-label="Close private note"
              type="button"
            >
              x
            </button>
          </div>
          <p>{privateNote.text}</p>
          <button
            className="search-private-note-profile-link"
            onClick={() => handleViewProfile(user.id)}
            type="button"
          >
            View Profile to Edit
          </button>
        </div>
      )}

    </div>
  </div>
);
})

    )}
  </div>
)}

      <div className="group-section">

	<div className="group-header">
  <span className="group-label" onClick={() => setShowGroups(!showGroups)}>Groups {showGroups ? '▲' : '▼'}</span>
  <button className="create-group-button" onClick={() => setShowCreateGroupModal(true)}>
    + Create Group
  </button>
</div>

	{showCreateGroupModal && (
 <div
  className="create-group-inline-modal"
  onClick={(e) => e.stopPropagation()}
  style={{
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    maxWidth: '400px',
    width: '100%',
    boxShadow: '0 0 10px rgba(0,0,0,0.3)',
  }}
>
  <h3 style={{ marginBottom: '12px' }}>Create New Group</h3>

  <input
    type="text"
    placeholder="Enter group name"
    value={newGroupName}
    onChange={(e) => setNewGroupName(e.target.value)}
    style={{
      width: '100%',
      padding: '8px',
      marginBottom: '12px',
      borderRadius: '4px',
      border: '1px solid #ccc'
    }}
  />

  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
    <button
      onClick={() => setShowCreateGroupModal(false)}
      style={{
        marginRight: '8px',
        padding: '6px 10px',
        border: 'none',
        borderRadius: '4px',
        backgroundColor: '#ccc',
        color: '#333'
      }}
    >
      Cancel
    </button>
    <button
      onClick={handleCreateGroup}
      style={{
        padding: '6px 12px',
        border: 'none',
        borderRadius: '4px',
        backgroundColor: '#007bff',
        color: 'white'
      }}
    >
      Create
    </button>
  </div>
</div>
)}

        {showGroups && (
          <div className="group-list">
     {groups.map((group) => (
  <div
    className="group-item"
    key={group.id}
   onClick={async () => {
  console.log('Opening group:', group.id);
  const groupConversationRef = doc(db, 'conversations', group.id);

  try {
    const docSnap = await getDoc(groupConversationRef);
    if (!docSnap.exists()) {
      await setDoc(groupConversationRef, {
        name: group.name,
        isGroup: true,
        members: group.members,
        createdAt: new Date(),
      });
      console.log('Group conversation initialized.');
    }

    // ✅ Mark as viewed only when user *enters* the conversation
    if (currentUser?.uid) {
      markConversationViewedBestEffort(group.id, currentUser.uid);
      console.log(`👁️ Marked group ${group.name} as viewed`);
    }

    navigate(`/group/${group.id}`, { state: { currentUser } });


    // ✅ Trigger local refresh (dot should clear instantly)
    await refreshGroupList();
  } catch (err) {
    console.error('Error initializing group conversation:', err);
  }
}}
    style={{ cursor: 'pointer' }}
  >
   <h3>
  {localGroupNames[group.id] || group.name}
  {group.hasUnread && <span className="unread-dot" />}
</h3>


  </div>
))}
          </div>
        )}
      </div>

	{showSingleAddModal && (
  <div
    className="modal-overlay"
    onClick={() => setShowSingleAddModal(false)}
    style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 999
    }}
  >
    <div
      className="modal-content"
      onClick={(e) => e.stopPropagation()}
      style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        maxWidth: '400px',
        width: '100%',
        boxShadow: '0 0 10px rgba(0,0,0,0.3)',
      }}
    >
      <h3>Select List</h3>
      {userLists.length === 0 ? (
        <p style={{ color: '#888' }}>You don’t have any lists yet.</p>
      ) : (
        userLists.map((list) => (
          <div
            key={list.id}
            onClick={async () => {
		     // ✅ Set loading state for this list
     			if (addingToListId) return; // prevent multiple simultaneous clicks
     			setAddingToListId(list.id);
              try {
         if (userToAddToList) {
  const added = await handleAddUserToList(userToAddToList.id, list.id);
  if (added) {
    await fetchListsAndMembers(); // ✅ refresh list UI
    toast.success(`Added to "${list.name}"`);
  } else {
    toast.info('User is already in this list.');
  }
}
 else {
        let addedCount = 0;
        let skippedCount = 0;

for (const uid of selectedSearchUserIds) {
  const added = await handleAddUserToList(uid, list.id);
  if (added) {
    addedCount++;
  } else {
    skippedCount++;
  }
}

  await fetchListsAndMembers();

if (addedCount > 0) {
  toast.success(`Added ${addedCount} user(s) to "${list.name}"`);
}
if (skippedCount > 0 && addedCount === 0) {
  toast.info('All selected users are already in this list.');
}

setSelectedSearchUserIds([]);
setSelectAllResults(false);

                  setSelectedSearchUserIds([]);
                  setSelectAllResults(false);
                }

                setShowSingleAddModal(false);
              } catch (err) {
                console.error('Failed to add user(s) to list:', err);
                toast.error('Failed to add.');
              } finally {
		   setAddingToListId(null); // ✅ Reset loading state
	             }
            }}
            style={{
              padding: '8px 0',
              borderBottom: '1px solid #eee',
              cursor: addingToListId === list.id ? 'not-allowed' : 'pointer',
	                color: addingToListId === list.id ? '#999' : '#007bff',
     				  opacity: addingToListId === list.id ? 0.6 : 1
            }}
          >
            {addingToListId === list.id ? '⏳ Adding…' : list.name}
          </div>
        ))
      )}

      <div style={{ textAlign: 'right', marginTop: '12px' }}>
        <button onClick={() => setShowSingleAddModal(false)}>Cancel</button>
      </div>
    </div>
  </div>
)}




<div className="dm-section" style={{ borderBottom: '1px solid #ccc', borderTop: '1px solid #ccc', paddingBottom: '12px', marginBottom: '16px' }}>
  <div className="dm-header">Direct Messages:</div>

  {dmConversations.length === 0 ? (
    <p style={{ padding: '8px 12px', color: '#999' }}>No conversations yet.</p>
  ) : (
    <>
      {dmConversations.map((c) => {
        const myUid = currentUser?.uid;
        const otherUid = Array.isArray(c.members) ? c.members.find(u => u !== myUid) : null;
        const name = c.memberProfiles?.[otherUid]?.firstInitialLastName || 'Unknown';
        const agency = c.memberProfiles?.[otherUid]?.agency || 'Unknown Agency';

        return (
          <div
            key={c.id}
            className="user-item"
            onClick={async () => {
              const resolvedConvoId = otherUid
                ? await ensureDirectConversation(otherUid)
                : c.id;

              if (!resolvedConvoId) {
                return;
              }

              markConversationViewedBestEffort(resolvedConvoId, myUid);
              navigate(`/direct/${resolvedConvoId}`);

            }}
            style={{ position: 'relative', cursor: 'pointer' }}
          >
            {`${name}, (${agency})`}
            {c.hasUnread && <span className="unread-dot" />}
          </div>
        );
      })}
    </>
  )}
</div>



<div className="custom-lists-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '16px 0 8px' }}>
  <h3 style={{ fontSize: '1.1rem', fontWeight: '600' }}>My Contact Lists</h3>
  <button
    onClick={() => setShowCreateListModal(true)}
    style={{
      backgroundColor: '#007bff',
      color: 'white',
      padding: '6px 10px',
      borderRadius: '6px',
      fontSize: '0.9rem',
      border: 'none',
      cursor: 'pointer'
    }}
  >
    + Create New List
  </button>
</div>
<div className="custom-lists-section">
  {userLists.map((list) => (
  <div key={list.id} className="user-list-block">
  <div className="list-header">
    <h4
      onClick={() =>
        setExpandedListId((prevId) => (prevId === list.id ? null : list.id))
      }
      style={{
        marginBottom: '8px',
        cursor: 'pointer',
        color: '#007bff',
        textDecoration: 'none',
      }}
    >
      {editingListId === list.id ? (
        <input
          type="text"
          value={editedListName}
          onChange={(e) => setEditedListName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSaveListName(list.id);
          }}
          style={{ fontSize: '1rem' }}
        />
      ) : (
        <>
          {list.name}{' '}
          <span style={{ color: '#666', fontWeight: 'normal' }}>
            ... {listMembers[list.id]?.length || 0}
          </span>
        </>
      )}
    </h4>

    <div className="list-actions">
      {editingListId === list.id ? (
        <button onClick={() => handleSaveListName(list.id)}>Save</button>
      ) : (
        <button onClick={() => {
          setEditedListName(list.name);
          setEditingListId(list.id);
        }}>
          ✏️
        </button>
      )}

      <button onClick={() => handleDeleteList(list.id)}>🗑️</button>
    </div>
  </div>

  {expandedListId === list.id && (
    <>
      {listMembers[list.id]?.length > 0 ? (
        <ul className="list-users" style={{ paddingLeft: '16px' }}>
          {listMembers[list.id].map((u) => (
           <li key={u.id} className="list-user">

                <div>
  <div>{u.firstInitialLastName || u.displayId || u.email}</div>
  <div style={{ fontSize: '0.85em', color: '#555' }}>
    {u.rank || 'N/A'}, {u.agency || 'Unknown Agency'}
  </div>
</div>

                <div className="user-actions">

                 <button
  onClick={() =>
    setOpenMenu((prev) =>
      prev?.listId === list.id && prev?.userId === u.id
        ? null
        : { listId: list.id, userId: u.id }
    )
  }
  style={{
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '26px',
  }}
>
  ...
</button>


                {openMenu?.listId === list.id && openMenu?.userId === u.id && (
  <div ref={menuRef} className="user-menu show">
    <div
      className="user-menu-item"
      onClick={() => {
        handleMessageUser(u.id);
        setOpenMenu(null);
      }}
    >
      Message
    </div>

{/* CALL BUTTON in the custom lists
    <div
      className="user-menu-item"
      onClick={() => {
        handleCallUser(u.id);
        setOpenMenu(null);
      }}
    >
      Call
    </div>
	*/}
    <div
      className="user-menu-item"
      onClick={() => {
        handleViewProfile(u.id);
        setOpenMenu(null);
      }}
    >
      View Profile
    </div>
    <div
      className="user-menu-item"
     onClick={() => {
  handleRemoveUserFromList(u.id, list.id);
  setOpenMenu(null);
}}

    >
      Remove from List
    </div>
  </div>
)}




                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p
            style={{
              fontSize: '0.9rem',
              color: '#888',
              paddingLeft: '16px',
              marginTop: '4px',
            }}
          >
            No users added yet.
          </p>
        )}
      </>
    )}
  </div>
))}
</div>

   {showCreateListModal && (
  <div
    className="modal-overlay"
    onClick={() => setShowCreateListModal(false)}
    style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 999
    }}
  >
    <div
      className="modal-content"
      onClick={(e) => e.stopPropagation()}
      style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        maxWidth: '400px',
        width: '100%',
        boxShadow: '0 0 10px rgba(0,0,0,0.3)',
      }}
    >
      <h3 style={{ marginBottom: '12px' }}>Create New List</h3>
      <input
        type="text"
        placeholder="Enter list name"
        value={newListName}
        onChange={(e) => setNewListName(e.target.value)}
        style={{
          width: '100%',
          padding: '8px',
          marginBottom: '12px',
          borderRadius: '4px',
          border: '1px solid #ccc'
        }}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <button
          onClick={() => setShowCreateListModal(false)}
          style={{
            marginRight: '8px',
            padding: '6px 10px',
            border: 'none',
            borderRadius: '4px',
            backgroundColor: '#ccc',
            color: '#333'
          }}
        >
          Cancel
        </button>
        <button
          onClick={handleCreateList}
          style={{
            padding: '6px 12px',
            border: 'none',
            borderRadius: '4px',
            backgroundColor: '#007bff',
            color: 'white'
          }}
        >
          Create
        </button>
      </div>
    </div>
  </div>
)}


      {showGroupModal && (
  <div className="group-modal-overlay">
    <div className="group-modal">
      <h3>Select Group to Add Member</h3>

      {groupsLoading ? (
        <p>Loading groups...</p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {userGroups.map((group) => {
  const usersToCheck = groupSelectorUser
    ? [groupSelectorUser.id]
    : selectedSearchUserIds;

  const someUsersNotInGroup = usersToCheck.some(uid =>
    !group.members.includes(uid)
  );

  return (
    <li
      key={group.id}
      style={{
        padding: '8px',
        cursor: someUsersNotInGroup ? 'pointer' : 'not-allowed',
        color: someUsersNotInGroup ? '#000' : '#999',
        backgroundColor: '#f9f9f9',
        marginBottom: '6px',
        borderRadius: '4px',
      }}
      onClick={() => {
        if (someUsersNotInGroup) {
          if (groupSelectorUser) {
            handleAddUserToExistingGroup(group.id, groupSelectorUser.id);
          } else {
            const usersToActuallyAdd = selectedSearchUserIds.filter(
              uid => !group.members.includes(uid)
            );
            handleAddUsersToExistingGroup(group.id, usersToActuallyAdd);
          }
        }
      }}
    >
      {group.name}
      {!someUsersNotInGroup && ' (All selected already in group)'}
   				 </li>
 				 );
	   })}
        </ul>
      )}

      <div className="group-modal-actions" style={{ marginTop: '12px' }}>
        <button onClick={() => setShowGroupModal(false)}>Close</button>
 										     </div>
   									 </div>
 								 </div>
			)} 
        <ToastContainer />
       </div>
    )}
  </>
);
}

export default Messaging;

